// extracted by mini-css-extract-plugin
module.exports = {"docPreviewContainer":"docPreviewContainer_2o_Zn","cardContent":"cardContent_1wmeH","docpreviewImg":"docpreviewImg_2B10t"};